import { render, staticRenderFns } from "./add-content-placeholder.vue?vue&type=template&id=4b01b36d&scoped=true"
import script from "./add-content-placeholder.vue?vue&type=script&lang=js"
export * from "./add-content-placeholder.vue?vue&type=script&lang=js"
import style0 from "./add-content-placeholder.vue?vue&type=style&index=0&id=4b01b36d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b01b36d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b01b36d')) {
      api.createRecord('4b01b36d', component.options)
    } else {
      api.reload('4b01b36d', component.options)
    }
    module.hot.accept("./add-content-placeholder.vue?vue&type=template&id=4b01b36d&scoped=true", function () {
      api.rerender('4b01b36d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/add-content-placeholder.vue"
export default component.exports